import React from "react";

function Form(props) {
    return(
        <form className="form-inline d-flex justify-content-center">
            <input type="text" className="form-control" id="newLinkName" placeholder="Name" value={props.linkName} onChange={props.linkNameChange}/>
            <input type="text" className="form-control" id="newLinkURL" placeholder="URL" value={props.linkUrl} onChange={props.linkUrlChange}/>
            <button type="submit" className="btn btn-primary" onClick={props.addLink}>Add</button>
      </form>
    );
}

export default Form;